module.exports = __webpack_public_path__ + "static/img/依法治校.788b261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/依法治校.png
// module id = 32kO
// module chunks = 1